import { gql } from 'apollo-angular';

import { CONDITION_FRAGMENT } from 'graphql/fragments/condition';

export const CUSTOMER_WITH_CONDITIONS_FRAGMENT = gql`
  fragment CustomerWithConditionsFragment on Customer {
    name
    id
    customerNumber
    useCustomConditions
    conditions {
      ...ConditionFragment
    }
  }
  ${CONDITION_FRAGMENT}
`;
